<template>
	<div>
		<input
			:id="id"
			type="checkbox"
			:name="`${id}-slide-down-accordion`"
			:checked="isChecked"
		/>
		<label
			class="relative flex w-full cursor-pointer justify-between py-5"
			:for="id"
		>
			<h3
				:class="[
					titleFont,
					titleFontWight,
					titleFontSize,
					titleTextAlign,
					titleMargin,
					titlePaddingRight,
				]"
			>
				<slot name="title"></slot>
			</h3>
			<div class="accordion-icon-wrapper absolute right-0">
				<IconPlus class="icon-plus top-1 h-5 w-5 duration-200" />
				<IconMinus class="icon-minus top-1 h-5 w-5 duration-200" />
			</div>
		</label>
		<div class="accordion-content">
			<slot name="content"></slot>
		</div>
	</div>
</template>

<script setup>
import IconPlus from '@/assets/svg/common/ico-svg-plus.svg'
import IconMinus from '@/assets/svg/common/ico-svg-minus.svg'

const props = defineProps({
	titlePaddingY: {
		type: String,
		default: 'py-5',
		required: false,
	},
	titlePaddingRight: {
		type: String,
		default: 'pr-5',
		required: false,
	},
	titleFont: {
		type: String,
		default: 'font-body',
		required: false,
	},
	titleFontWight: {
		type: String,
		default: 'font-medium',
		required: false,
	},
	titleFontSize: {
		type: String,
		default: 'text-xl',
		required: false,
	},
	titleTextAlign: {
		type: String,
		default: 'text-left',
		required: false,
	},
	titleMargin: {
		type: String,
		default: 'm-0',
		required: false,
	},
	isChecked: {
		type: Boolean,
		default: false,
		required: false,
	},
})

const id = useId()
</script>
